<template>
    <div>
        <main class="flex flex-col overflow-scroll border-gray-200 border rounded-2xl p-2 bg-white" :key="key">
            <div class="ml-2 flex" v-if="users == null">
                Loading user data....
            </div>
            <div class="mx-2" v-else>
                <div class="text-lg mb-1">Current users :</div>
                <div class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                    <div class="w-96 border-r border-l border-gray-200 px-2 py-1">User</div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1">Status</div>
                    <div class="flex-1 -ml-px border-r border-gray-200 px-2 py-1">Permissions</div>
                    <div class="w-6 flex-shrink-0"></div>
                </div>
                <div class="flex -mt-px border-t border-b border-gray-200 bg-white"
                     v-for="user in users">
                    <div class="w-96 border-r border-l border-gray-200 px-2 py-1 truncate">
                        <div class="text-gray-600 w-full truncate">{{ user.name }}</div>
                        <!--
                        <div class="text-xs text-gray-400 w-full whitespace-pre-wrap truncate">
                            <span class="inline truncate" v-text="user.emailAddress"></span>
                            <span class="inline truncate" v-text="user.phoneNumber"></span>
                        </div>
                        -->
                    </div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1 text-gray-500" v-if="user.legacy">Legacy</div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1 text-green-500" v-else>Accepted</div>
                    <div
                        class="flex-1 ml-0 mb-px border-r border-gray-200 truncate"
                        v-if="opened[user.id]"
                    >
                        <div class="pt-1.5 pl-2 pb-1 text-xs text-gray-400 truncate hover:bg-blue-50 cursor-pointer" @click="opened = []" cursor-pointer>
                            {{ user.permissions.length }} permissions
                        </div>
                        <div class="w-full px-2 py-px whitespace-pre-wrap truncate hover:bg-blue-50 cursor-pointer"
                             v-for="permission in user.permissions" @click="editPermissions(user,permission)">
                            <organization-permission-line :permission="permission"></organization-permission-line>
                        </div>
                        <div
                            class="w-full px-2 py-1 whitespace-pre-wrap truncate hover:bg-blue-50 cursor-pointer text-gray-400 italic text-xs"
                            @click="addPermissions(user)">
                            <div class="w-full truncate">
                                <span class="fa fa-plus"></span> Add permission...
                            </div>
                        </div>
                    </div>
                    <div class="flex-1 ml-0 mb-px border-r border-gray-200 truncate hover:bg-blue-50 cursor-pointer" v-else
                         @click="opened = []; opened[user.id]=true">
                        <div class="pt-1.5 pl-2 text-xs text-gray-400">{{ user.permissions.length }} permissions</div>
                    </div>
                    <div class="w-6 flex-shrink-0">
                        <ui-dropdown menu-class="p-3 w-72">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-3 h-3 mt-2 ml-1 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-trash" danger
                                                  @click="removeUser(user);close()">
                                    Remove User
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>

                    </div>
                </div>
                <div class="text-lg my-1">Current invitations :</div>
                <div class="flex border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold ">
                    <div class="w-96 border-r border-l border-gray-200 px-2 py-1">Email Address/Phone Number</div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1">Status</div>
                    <div class="flex-1 -ml-px border-r border-gray-200 px-2 py-1">Permissions</div>
                    <div class="w-6 flex-shrink-0"></div>
                </div>
                <div class="flex -mt-px border-t border-b border-gray-200 bg-white hover:bg-blue-50"
                     v-for="invitation in invitations">
                    <div class="w-96 border-r border-gray-200 px-2 py-1 truncate">
                        <div class="text-gray-600 w-full truncate">
                            {{ invitation.emailAddressOrPhoneNumber }}
                            <span class="text-gray-400 text-xs">({{ invitation.name }})</span>
                        </div>
                        <div class="text-xs text-gray-400 truncate" v-if="invitation.lastSent">Last sent
                            {{ moment(invitation.lastSent).format('Do MMMM YYYY, h:mm a') }}
                        </div>
                    </div>
                    <div class="w-20 border-r border-gray-200 px-2 py-1"
                         :class="{'Pending':'text-orange-600','Expired':'text-red-600','Revoked':'text-red-600'}[invitation.status]"
                         v-text="invitation.status"></div>
                    <div
                        class="flex-1 -ml-px border-r border-gray-200 truncate hover:border-gray-200">
                        <div class="w-full px-2 py-1 whitespace-pre-wrap truncate"
                             v-for="permission in invitation.permissions">
                            <organization-permission-line :permission="permission"></organization-permission-line>
                        </div>
                    </div>
                    <div class="w-6 flex-shrink-0">
                        <ui-dropdown menu-class="p-3 w-72">
                            <template #default="{ toggle }">
                                <button @click="toggle"
                                        class="w-3 h-3 mt-2 ml-1 flex items-center justify-center text-gray-300 text-xs hover:text-gray-500 focus:outline-none focus:ring-0 focus:z-10 relative rounded">
                                    <i class="fa fa-ellipsis-h"></i>
                                </button>
                            </template>
                            <template #menu="{ close }">
                                <ui-dropdown-item icon="fas fa-edit"
                                                  v-if="invitation.status=='Expired' || invitation.status=='Pending' || invitation.status=='Revoked'"
                                                  @click="resend(invitation);close()">
                                    Re-send Invitation
                                </ui-dropdown-item>
                                <ui-dropdown-divider
                                    v-if="invitation.status=='Expired' || invitation.status=='Pending' || invitation.status=='Revoked'"/>
                                <ui-dropdown-item icon="fas fa-undo" danger v-if="invitation.status=='Pending'"
                                                  @click="revoke(invitation);close()">
                                    Revoke Invitation
                                </ui-dropdown-item>
                                <ui-dropdown-item icon="fas fa-trash" danger @click="remove(invitation);close()"
                                                  v-if="invitation.status!=='Pending'">
                                    Remove Invitation
                                </ui-dropdown-item>
                            </template>
                        </ui-dropdown>
                    </div>
                </div>
            </div>

        </main>
        <div class="p-2 mt-2">
            <ui-button-new primary @click="extendInvite()">Invite new User</ui-button-new>
        </div>
    </div>
</template>

<script>
import UiButton from "../ui/UiButton.vue";
import {Organization, PackageNew} from "@models";
import User from "../../services/User";
import OrganizationPermissionLine from "./OrganizationPermissionLine.vue";
import moment from "moment";
import UiDropdown from "../ui/UiDropdown.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";

export default {
    components: {UiDropdownItem, UiDropdown, OrganizationPermissionLine, UiButton},
    props: [],
    data() {
        return {
            users: null,
            invitations: null,
            user: null,
            availablePermissions: null,
            organization: null,
            packages: Array,
            key: 0,
            moment,
            opened: [],
        }
    },
    watch: {},
    computed: {},
    methods: {
        async revoke(invitation) {
            this.$modals.confirm({
                title: `Revoke this invitation?`,
                paragraphs: ["Are you sure you wish to revoke this invitation?", "Once revoked, the original link send will no longer be valid - the invitation can be still re-sent if required."],
                button: 'Yes, revoke this invite',
                handle: async () => {
                    await Http.post(route('api.v2.organization.organization.invite.revoke', [invitation.id]))
                }
            })
        },
        async remove(invitation) {
            this.$modals.confirmDelete({
                title: `Are you sure you want to remove this invitation?`,
                paragraphs: ["Are you sure you wish to remove this invitation?", "Note - this only effects the invitation - if the invite has been accepted by a user, that users permissions will remain as-is."],
                button: 'Yes, remove this invite',
                handle: async () => {
                    await Http.delete(route('api.v2.organization.organization.invite.destroy', [invitation.id]))
                }
            })
        },
        async removeUser(user) {
            this.$modals.confirmDelete({
                title: `Are you sure you want to remove this user?`,
                paragraphs: ["Are you sure you wish to remove this user?", "This will remove ALL access rights and permissions for this organization."],
                button: 'Yes, remove this user',
                handle: async () => {
                    await Http.delete(route('api.v2.organization.organization.user.destroy', [user.id]))
                }
            })
        },
        async resend(invitation) {
            this.$modals.confirm({
                title: `Are you sure you want to re-send this invitation?`,
                paragraphs: ["Any previous sent invite links for this invitation will become invalid."],
                button: 'Yes, re-send this invite',
                handle: async () => {
                    await Http.post(route('api.v2.organization.organization.invite.resend', [invitation.id]))
                }
            })
        },
        extendInvite() {
            this.$modals.open('organization-invite-user', {
                handle: async (modal) => {
                    modal.close()
                },
                availablePermissions: this.availablePermissions,
                packages: this.packages,
                organization: this.organization,
            })
        },
        async reload() {
            this.organization = await Organization.current()
            this.users = this.organization.users
            this.invitations = this.organization.invitations
            this.availablePermissions = this.organization.availablePermissions
            this.key++;
        },
        addPermissions(user) {
            this.$modals.open('organization-add-permission', {
                handle: async (modal) => {
                    modal.close()
                    await this.reload();
                },
                permissions: user.permissions,
                availablePermissions: this.availablePermissions,
                packages: this.packages,
                organization: this.organization,
                userId: user.id,
            })
        },
        editPermissions(user, permission) {
            this.$modals.open('organization-edit-permission', {
                handle: async (modal) => {
                    modal.close()
                    await this.reload();
                },
                permissions: user.permissions,
                permission: permission,
                availablePermissions: this.availablePermissions,
                packages: this.packages,
                organization: this.organization,
                userId: user.id,
            })
        },
        async updateFromOrgListener(data) {
            this.organization = data.aggregate.data
            this.users = this.organization.users
            this.invitations = this.organization.invitations
            this.availablePermissions = this.organization.availablePermissions
            this.key++;
        }
    },
    async mounted() {
        await User.register()
        await this.reload();
        User.registerAggregate({
            "type": 'Organization',
            'id': this.organization.id,
        }, this.updateFromOrgListener)

        this.packages = await PackageNew.all()
        this.user = User.user
    }
}
</script>
